import { Box, Stack, Toolbar, Tooltip, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext, useEffect } from "react";
import { Translate } from "src/assets/data/index";
import RemoveCircle from "src/components/ui/svgIcon/RemoveCircle";
import SiteListItem from "./items-list/SiteListItem";
import { AppBarBox, BadgeButton, HeaderWaveLineBox } from "./style";
import { LightDarkMode } from "src/components/ui";
import { UserContext } from "src/contexts/UserContext";
import { MenuContext } from "src/contexts/menu-context/MenuContext";

const Header = () => {
  const { newTabItems, setNewTabItems, removeFromNewTab, setTab, selectedTab, setNewTabContent } =
    useContext(MenuContext);
  const theme = useTheme();
  const { businessID } = useContext(UserContext);

  const handleSelected = (item) => {
    setTab(item.id);
  };

  useEffect(() => {
    if (businessID) {
      setNewTabItems([]);
      setNewTabContent([]);
    }
  }, [businessID]);

  const handleRemoveItem = (item) => {
    let idActive;
    let itemActive = newTabItems.findIndex((p) => p.id === item.id);
    removeFromNewTab(item);
    if (itemActive < newTabItems.length - 1) {
      idActive = newTabItems[itemActive + 1]?.id;
      setTab(idActive);
    } else {
      idActive = newTabItems[itemActive - 1]?.id;
      setTab(idActive);
    }
  };
  return (
    <AppBarBox sx={{ zIndex: "0 !important" }}>
      <Toolbar>
        <HeaderWaveLineBox>
          <img src="/static/images/svg/ChainLine.svg" alt="avc header" />
        </HeaderWaveLineBox>
        <Stack flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
          <Stack flexDirection="row">
            <Stack justifyContent="center" alignItems="center">
              <SiteListItem />
            </Stack>
            <Box
              sx={{
                display: "flex",
                whiteSpace: "nowrap",
                overflow: "auto",
                width: "850px",
                "&::-webkit-scrollbar": {
                  width: 4,
                  height: 4,
                },
              }}
            >
              {newTabItems &&
                newTabItems?.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      flex: "0 0 auto",
                      // overflowX: "auto !important",
                      // display: "flex !important",
                    }}
                  >
                    <BadgeButton
                      variant="outlined"
                      sx={{
                        backgroundColor: item.id === selectedTab ? "primary.main" : "",
                        color: item.id === selectedTab ? "#fff !important" : "",
                      }}
                    >
                      <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                        <Typography
                          variant="body2"
                          onClick={() => {
                            // filteredTab(item);
                            handleSelected(item);
                          }}
                        >
                          {item.val}
                        </Typography>

                        <RemoveCircle
                          fontSize="small"
                          mr={2}
                          color={theme.palette.primary.contrastText}
                          onClick={() => {
                            handleRemoveItem(item);
                          }}
                        />
                      </Stack>
                    </BadgeButton>
                  </Box>
                ))}
            </Box>
          </Stack>

          <Box>
            <Stack flexDirection="row" alignItems="center">
              <Box sx={{ mx: 2, transform: "translate(3px)" }}>
                <LightDarkMode />
              </Box>
              <Box mx={1}>
                <Tooltip title={Translate.translate.texts.persian}>
                  <img src="/static/images/ir_Iran.png" alt="Iran" />
                </Tooltip>
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Toolbar>
    </AppBarBox>
  );
};

export default Header;
